import { getDayOfTheWeek } from "../../../lib/dateUtils";

const ConversationList = ({ 
  isLoadingConversations, 
  conversation, 
  selectedConversation, 
  openChat, 
  user,
  className 
}: any) => (
  <aside className={`list-view bg-white shadow-sm flex-col overflow-hidden flex-shrink-0 lg:border-l lg:border-r border-neutral-border ${className}`}>
    <div className="h-14 md:h-20 px-4 md:px-8 border-b border-neutral-border flex items-center justify-between gap-3">
      <h2 className="text-[16px] md:text-[18px] font-semibold text-neutral-text">
        Mensajes v2
      </h2>
      <div className="flex items-center gap-1">
        <button className="p-2 hover:bg-neutral-bg rounded-full transition-colors active:scale-90">
          <span className="material-symbols-outlined text-neutral-secondary text-[20px]">
            search
          </span>
        </button>
        <button className="p-2 hover:bg-neutral-bg rounded-full transition-colors active:scale-90">
          <span className="material-symbols-outlined text-neutral-secondary text-[20px]">
            settings
          </span>
        </button>
      </div>
    </div>
    <div className="px-4 md:px-6 py-3 md:py-4 border-b border-neutral-border">
      <div className="flex gap-2 md:gap-3">
        <button className="px-4 py-2 bg-primary text-white font-medium rounded-full text-[13px] md:text-[14px] hover:bg-ui-primary-hover transition-colors active:scale-95">
          Todos
        </button>
        <button className="px-4 py-2 text-neutral-text font-medium rounded-full text-[13px] md:text-[14px] hover:bg-neutral-bg transition-colors active:scale-95">
          No leído
        </button>
      </div>
    </div>

    {/* ini sidebarconversaciones */}
    <div className="flex-1 overflow-y-auto">
      {isLoadingConversations ? (
        <div className="flex flex-col">
          {[...Array(8)].map((_, index) => (
            <div key={index} className="px-4 md:px-6 py-4 flex gap-3 md:gap-4 animate-pulse">
              <div className="size-12 md:size-14 rounded-full bg-gray-200 shrink-0"></div>
              <div className="flex-1 min-w-0 space-y-2">
                <div className="flex justify-between items-start">
                  <div className="h-4 bg-gray-200 rounded w-32"></div>
                  <div className="h-3 bg-gray-200 rounded w-16"></div>
                </div>
                <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                <div className="h-3 bg-gray-200 rounded w-1/2"></div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        Array.isArray(conversation) &&
        conversation.map((conv: any) => {
          // if (Array.isArray(conv?.tbComplaints) && conv?.tbComplaints?.length > 0) {
          return (
            <div
              key={conv.conversationId}
              onClick={() => openChat(conv)}
              className={`px-4 md:px-6 py-4 flex gap-3 md:gap-4 cursor-pointer border-l-4 transition-colors 
                ${selectedConversation?.conversationId === conv.conversationId
                  ? "border-primary bg-[rgb(243,244,246)]"
                  : "border-transparent hover:bg-neutral-bg"
                }`}
            >
              <div
                className="size-12 md:size-14 rounded-full bg-cover bg-center shrink-0 ring-2 ring-white"
                style={{
                  backgroundImage: `url('${(user?.id == conv?.userIdOne
                    ? conv?.userIdTwoNavigation?.photoLink
                    : conv?.userIdOneNavigation?.photoLink) || `/LogoJOM-MORADO.svg`
                    }')`,
                }}
              ></div>

              <div className="flex-1 min-w-0">
                {conv?.tbComplaints?.length > 0 && (
                  <p className="text-[14px] text-neutral-text font-medium truncate mb-0.5">
                    {conv?.tbComplaints[0]?.complainCode ?? ""}
                  </p>
                )}
                <div className="flex justify-between items-start mb-1">
                  <span className="text-[14px] font-semibold text-neutral-text truncate">
                    {user?.id == conv?.userIdOne
                      ? conv?.userIdTwoNavigation?.name
                      : conv?.userIdOneNavigation?.name}
                  </span>
                  <span className="text-[12px] text-neutral-secondary">
                    {getDayOfTheWeek(conv?.creationDate)}
                  </span>
                </div>
                <p className="text-[14px] text-neutral-text font-medium truncate mb-0.5">
                  {conv?.tmMessages[0]?.body ?? ""}
                </p>
                <p className="text-[12px] text-neutral-secondary truncate">
                  {/* {getDayOfTheWeek(conv?.creationDate)} */}
                </p>
              </div>
            </div>
          )
          // }
        })
      )}
    </div>
    {/* end sidebar conversaciones  */}
  </aside>
);

export default ConversationList;